import type { LocaleMetadata } from "../types";

import { resolveLocaleCodeFromHostname } from "../resolve/resolve-locale-code-from-hostname";
import { getLocaleMetadata } from "./locale-registry";

/**
 * Resolves locale metadata from a registered site domain (e.g. `homeinstead.ca`).
 * Callers that already have a site ID need domain, language, and canonical origin
 * without re-implementing hostname-to-locale lookup.
 */
function getLocaleBySiteId(siteId: string): LocaleMetadata {
  if (!siteId.trim()) {
    throw new Error("siteId is required for locale lookup");
  }

  const localeCode = resolveLocaleCodeFromHostname(siteId);

  if (!localeCode) {
    throw new Error(`Unknown siteId for locale lookup: ${siteId}`);
  }

  return getLocaleMetadata(localeCode);
}

export { getLocaleBySiteId };
